/**
 * created by lei lei on 2020/5/9
 * 组件路由
 */
import React, {Component} from 'react';
import ActivityPendingComponents from "../view/desktop/components/activityPending/ActivityPendingComponents";
import ActivityOtherPendingComponents from "../view/desktop/components/activityPending/ActivityOtherPendingComponents";

import ActivityTrendsComponents from "../view/desktop/components/activityTrends/ActivityTrendsComponents";
import TopicSubmissionReminderComponents from "../view/desktop/components/activityTrends/TopicSubmissionReminderComponents";
import FollowUpCorrespondenceComponents from "../view/desktop/components/activityTrends/FollowUpCorrespondenceComponents";
import ActivityCompletionComponents from "../view/desktop/components/activityCompletion/ActivityCompletionComponents";
import ActivityRankingComponents from "../view/desktop/components/activityRanking/ActivityRankingComponents";
import ResourceStaticComponents from "../view/desktop/components/resourceStatic/ResourceStaticComponents";
import PublishRankingsComponents from "../view/desktop/components/publishRank/PublishRankingsComponents";
import Head from'../view/desktop/components/head/Head'
import Shortcuts from'../view/desktop/components/shortcuts/Shortcuts'
import ActivityPendingAllComponents from "../view/desktop/components/activityPending/ActivityPendingAllComponents";
import IconStatisticComponents from '../view/components/iconStatistic/IconStatisticComponents'
import NumberArticlesComponents from '../view/components/numberArticles/NumberArticlesComponents'
import MediaInformationComponents from '../view/components/mediaInformation/MediaInformationComponents'
import CustomTableComponents from '../view/components/customTable/CustomTableComponents'
import TrendAnalysisComponents from '../view/components/trendAnalysis/TrendAnalysisComponents'
import NewsActivityIndexForm from "../containers/newsActivity/NewsActivityIndex";
import EditorsDemo from"../view/components/editor/EditorsDemo"
import {NO_FRAME} from "../constants";
import File from '../view/components/resourcePool/file/File';
import ResourcePoolDemo from '../view/components/resourcePool/ResourcePoolDemo';
import HoldAll from '../view/components/holdAll/HoldAll';
import HoldAllDome from '../view/components/holdAll/HoldAllDemo';
import CategoryInfo from '../view/components/resourcePool/categoryInfo/CategoryInfo';
export  const ComponentsRouter =[
    {
        path: "/view/desktop/components/Head",
        component: Head
    },
    {
        path: "/view/desktop/components/ActivityPendingComponents",
        component: ActivityPendingComponents
    },
    {
        path: "/view/desktop/components/ActivityOtherPendingComponents",
        component: ActivityOtherPendingComponents
    },
    {
        path: "/view/desktop/components/ActivityTrendsComponents",
        component: ActivityTrendsComponents
    },
    {
        path: "/view/desktop/components/TopicSubmissionReminderComponents",
        component: TopicSubmissionReminderComponents
    },
    {
        path: "/view/desktop/components/FollowUpCorrespondenceComponents",
        component: FollowUpCorrespondenceComponents
    },
    {
        path: "/view/desktop/components/ActivityCompletionComponents",
        component: ActivityCompletionComponents
    },
    {
        path: "/view/desktop/components/ActivityRankingComponents",
        component: ActivityRankingComponents
    },
    {
        path: "/view/desktop/components/ResourceStaticComponents",
        component: ResourceStaticComponents
    },
    {
        path: "/view/desktop/components/PublishRankingsComponents",
        component: PublishRankingsComponents
    },
    {
        path: "/view/desktop/components/Shortcuts",
        component: Shortcuts
    },
    {
        path: "/view/desktop/components/ActivityPendingAllComponents",
        component: ActivityPendingAllComponents
    },
    {
        path: "/view/components/IconStatisticComponents",//图标类粉丝数
        component: IconStatisticComponents
    },
    {
        path: "/view/components/NumberArticlesComponents",//横向管控粉丝数列表
        component: NumberArticlesComponents
    },
    {
        path: "/view/components/MediaInformationComponents",//媒体信息
        component: MediaInformationComponents
    },
    {
        path: "/view/components/CustomTableComponents",//自定义表格
        component: CustomTableComponents
    },
    {
        path: "/view/components/TrendAnalysisComponents",//横向管控趋势分析
        component: TrendAnalysisComponents
    },
    /*    {
            path: "/view/components/MyMediaInformation",
            component: <MyMediaInformation/>
        },*/

    {
        path: "/newsActivityIndex/newsActivityIndex/:topicSelectionId/:operation",//活动
        component: NewsActivityIndexForm
    },{
        path: "/newsActivityIndex/newsActivityIndex/interviewEventId/:interviewEventId/:operation",//专题项目
        component: NewsActivityIndexForm
    },{
        path: "/newsActivityIndex/newsActivityIndex/interviewId/:interviewId/:operation",//专题项目
        component: NewsActivityIndexForm
    },{
        path: "/newsActivityIndex/newsActivityIndex",//活动
        component: NewsActivityIndexForm
    },
    {
        path: "/demo/editorsDemo",//活动
        component: EditorsDemo ,frame:NO_FRAME
    },
    {
        path: "/view/File",//上传文件
        component: File
    },
    {
        path: "/view/ResourcePoolDemo",//上传文件
        component: ResourcePoolDemo
    },
    {
         path: "/view/HoldAll",//穿梭框
         component: HoldAll
     },
    {
        path: "/view/HoldAllDome", //全部资源 的demo
        component: HoldAllDome
    },
    {
        path: "/view/CategoryInfo",//全部资源 的demo
        component: CategoryInfo
    },
];